/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SendSubscriptionTransactionInfoResponse
 */
export interface SendSubscriptionTransactionInfoResponse {
    /**
     * 
     * @type {boolean}
     * @memberof SendSubscriptionTransactionInfoResponse
     */
    paymentSkipped: boolean;
}

/**
 * Check if a given object implements the SendSubscriptionTransactionInfoResponse interface.
 */
export function instanceOfSendSubscriptionTransactionInfoResponse(value: object): value is SendSubscriptionTransactionInfoResponse {
    if (!('paymentSkipped' in value) || value['paymentSkipped'] === undefined) return false;
    return true;
}

export function SendSubscriptionTransactionInfoResponseFromJSON(json: any): SendSubscriptionTransactionInfoResponse {
    return SendSubscriptionTransactionInfoResponseFromJSONTyped(json, false);
}

export function SendSubscriptionTransactionInfoResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SendSubscriptionTransactionInfoResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'paymentSkipped': json['paymentSkipped'],
    };
}

export function SendSubscriptionTransactionInfoResponseToJSON(json: any): SendSubscriptionTransactionInfoResponse {
    return SendSubscriptionTransactionInfoResponseToJSONTyped(json, false);
}

export function SendSubscriptionTransactionInfoResponseToJSONTyped(value?: SendSubscriptionTransactionInfoResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'paymentSkipped': value['paymentSkipped'],
    };
}

